<script>
import { getMiniUrl } from '@/axios/applyForm/commonForm.js';
export default {
  data() {
    return {};
  },
  mounted() {
    this.$toast.loading({
      duration: 0, // 持续展示 toast
      forbidClick: true,
      message: "加载中",
    });
    getMiniUrl(this.$route.query).then(res => {
      if (res.errcode === 0) {
        window.location.href = res.data;
      } else {
        this.$toast(res.errmsg || '网络错误，请重试~')
      }
    }).catch(() => {
      this.$toast('网络错误，请重试~')
    }).finally(() => {
      this.$toast.clear();
    });
  },
  methods: {},
};
</script>

